import { z } from "zod";
export const GetActivitiesQuery = z
    .object({ limit: z.coerce.number().int().min(1).max(100).default(50) })
    .default({ limit: 50 });
export const ActivitySummary = z.object({
    id: z.string().uuid(),
    provider: z.string(),
    activityType: z.string(),
    startedAt: z.coerce.date(),
    endedAt: z.coerce.date().nullable(),
    steps: z.number().int().nullable(),
    distanceMeters: z.number().int().nullable(),
    durationSeconds: z.number().int().nullable(),
});
export const GetActivitiesResponse = z.object({ activities: z.array(ActivitySummary) });
export const ActivityParams = z.object({ activityId: z.string().uuid() });
export const ActivityRouteResponse = z.object({ encodedPolyline: z.string(), bounds: z.unknown() });
//# sourceMappingURL=activities.js.map